module.exports = __webpack_public_path__ + "static/fonts/righteous-regular.bea21d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/righteous-regular.ttf
// module id = QOii
// module chunks = 1